const styles = {
  header: {
    backgroundColor: '#f2aa00',
    color: '#fff',
    fontSize: '18px',
  },
};

export default styles;
